import { client } from '../client';
import Endpoints from '../Endpoints';
import { getData } from '../apiUtils';

export default async function getUserProfile() {
  return client.post(Endpoints.login, {}).then(getData);
}
